// Generated locale bundle for Control UI translations.
// Run `pnpm ui:i18n:sync` instead of editing this file directly.
import type { TranslationMap } from "../lib/types.ts";

export const zh_CN: TranslationMap = {
  common: {
    health: "健康状况",
    ok: "正常",
    yes: "是",
    no: "否",
    active: "活跃",
    loading: "加载中…",
    refreshing: "刷新中…",
    online: "在线",
    offline: "离线",
    connect: "连接",
    connected: "已连接",
    refresh: "刷新",
    reload: "重新加载",
    reset: "重置",
    probe: "探测",
    call: "调用",
    confirm: "确认",
    cancel: "取消",
    next: "下一步",
    back: "返回",
    create: "创建",
    copy: "复制",
    copied: "已复制！",
    copyCode: "复制代码",
    delete: "删除",
    dismiss: "关闭",
    unselect: "取消选择",
    enabled: "已启用",
    disabled: "已禁用",
    none: "无",
    na: "不适用",
    never: "从未",
    configured: "已配置",
    running: "运行中",
    linked: "已关联",
    mode: "模式",
    system: "系统",
    light: "浅睡",
    dark: "深色",
    baseUrl: "基础地址",
    lastStart: "上次启动",
    lastProbe: "上次探测",
    lastInbound: "上次入站",
    lastConnect: "上次连接",
    lastMessage: "上条消息",
    authAge: "认证时长",
    credential: "凭证",
    audience: "受众",
    publicKey: "公钥",
    probeOk: "探测成功",
    probeFailed: "探测失败",
    reloadConfig: "重新加载配置",
    loadConfig: "加载配置",
    loadApprovals: "加载审批",
    settingsSections: "设置分区",
    version: "版本",
    docs: "文档",
    theme: "主题",
    colorMode: "颜色模式",
    colorModeOption: "颜色模式：{mode}",
    resources: "资源",
    search: "搜索",
    save: "保存",
    saving: "保存中…",
    saveAndPublish: "保存并发布",
    importing: "导入中…",
    importFromRelays: "从 Relays 导入",
    showAdvanced: "显示高级选项",
    hideAdvanced: "隐藏高级选项",
    unsavedChanges: "你有未保存的更改",
    secondsAgo: "{count} 秒前",
    working: "处理中…",
    showQr: "显示二维码",
    relink: "重新关联",
    waitForScan: "等待扫描",
    logout: "退出登录",
  },
  channels: {
    health: {
      title: "频道健康状态",
      subtitle: "来自网关的频道状态快照。",
      noSnapshotYet: "尚无快照。",
    },
    generic: {
      subtitle: "频道状态和配置。",
    },
    gatewayUrlConfirmation: {
      title: "更改 Gateway URL",
      subtitle: "这将重新连接到其他 Gateway 服务器",
      warning: "仅当你信任此 URL 时才确认。恶意 URL 可能会危及你的系统安全。",
    },
    nostr: {
      profile: "个人资料",
      editProfile: "编辑个人资料",
      profilePicture: "头像",
      noProfile: "尚未设置个人资料。",
      noProfileHint: "点击“编辑个人资料”以添加你的姓名、简介和头像。",
      name: "姓名",
      displayName: "显示名称",
      about: "关于",
      advanced: "高级",
      profilePicturePreview: "头像预览",
      account: "账户",
      username: "用户名",
      usernameHelp: "短用户名（例如：satoshi）",
      bio: "简介",
      bioPlaceholder: "向大家介绍一下你自己...",
      bioHelp: "简短的个人简介或描述",
      displayNameHelp: "你的完整显示名称",
      avatarUrl: "头像 URL",
      avatarHelp: "你的头像图片的 HTTPS URL",
      bannerUrl: "横幅 URL",
      bannerHelp: "横幅图片的 HTTPS URL",
      website: "网站",
      websiteHelp: "你的个人网站",
      nip05Identifier: "NIP-05 标识符",
      nip05Help: "可验证标识符（例如：you@domain.com）",
      lightningAddress: "Lightning 地址",
      lightningHelp: "用于接收打赏的 Lightning 地址（LUD-16）",
    },
  },
  lazyView: {
    loadingTitle: "正在加载面板",
    errorTitle: "面板加载失败",
    errorSubtitle: "重新加载页面以加载最新的 Control UI 捆绑包，或在网络请求失败时重试。",
    retry: "重试",
    unknownError: "未知的模块加载错误。",
  },
  nodes: {
    pairing: {
      button: "配对移动设备",
      adminRequired: "需要管理员访问权限才能创建设置码。",
      title: "移动端配对",
      subtitle: "在移动应用中扫描此二维码以连接新手机。",
      generating: "正在创建安全设置码…",
      failed: "无法创建设置码。",
      qrAlt: "移动端配对二维码",
      qrUnavailable: "二维码不可用。请改为复制设置码。",
      copySetupCode: "复制设置码",
      newCode: "新代码",
      showSetupCode: "显示设置码",
      pending: "等待审核的设备请求：{count}",
      review: "审核",
      waiting: "移动应用扫描后会自动连接。",
      help: "配对帮助",
      manageDevices: "管理设备",
    },
    binding: {
      loadConfigHint: "加载配置以编辑绑定。",
      formModeHint: "将“配置”标签切换为表单模式，以在此处编辑绑定。",
      execNodeBinding: "Exec 节点绑定",
      execNodeBindingSubtitle: "使用 exec host=node 时，将代理固定到特定节点。",
      defaultBinding: "默认绑定",
      defaultBindingHint: "当代理未覆盖节点绑定时使用。",
      node: "节点",
    },
  },
  instances: {
    title: "已连接的实例",
    subtitle: "来自 Gateway 和客户端的在线信标。",
    showHosts: "显示主机和 IP",
    hideHosts: "隐藏主机和 IP",
    toggleHostVisibility: "切换主机可见性",
    noInstances: "尚未报告任何实例。",
    lastInput: "上次输入 {time}",
    reason: "原因 {reason}",
  },
  worktrees: {
    title: "托管工作树",
    subtitle: "由康桥集团AI助理管理的隔离代码库检出。",
    cleanNow: "立即清理",
    name: "名称",
    repo: "代码库",
    branch: "分支",
    status: "状态",
    lastActive: "上次活跃",
    actions: "操作",
    empty: "没有托管工作树。",
    restorable: "可恢复",
    restore: "恢复",
    confirmDelete: "为 {name} 创建快照并删除？",
    confirmForceDelete: "快照失败：{error}\n\n不创建快照直接删除？",
  },
  sessionsView: {
    title: "会话",
    subtitle: "活动会话密钥和每个会话的覆盖设置。",
    store: "存储：{path}",
    active: "活跃",
    limit: "限制",
    filters: "筛选",
    sourceFilters: "会话来源筛选器",
    global: "全局",
    unknown: "未知",
    archivedOnly: "仅已归档",
    activeTooltip: "在过去 {count} 分钟内更新。",
    limitTooltip: "要加载的最大会话数。",
    globalTooltip: "包含全局会话。",
    unknownTooltip: "包含未知会话。",
    archivedOnlyTooltip: "仅显示已归档的会话。",
    liveCount: "{count} live",
    minutesPlaceholder: "分钟",
    searchPlaceholder: "按密钥、代理、标签、类型筛选…",
    selected: "已选择 {count} 项",
    deleteSelected: "删除",
    selectAllOnPage: "选择本页全部",
    selectSession: "选择会话",
    optionalPlaceholder: "（可选）",
    key: "密钥",
    label: "标签",
    kind: "类型",
    updated: "已更新",
    tokens: "Token",
    compaction: "压缩",
    goal: "目标",
    goalNote: "目标备注",
    thinking: "思考",
    fast: "快速",
    verbose: "详细",
    reasoning: "推理",
    actions: "操作",
    addToWorkboard: "添加到 Workboard",
    openWorkboardCard: "打开 Workboard 卡片",
    noSessions: "未找到会话。",
    noSessionsMatchFilters: "没有会话符合你的筛选条件。",
    showAll: "显示全部",
    inherit: "继承",
    defaultOption: "默认（{value}）",
    offExplicit: "关闭（显式）",
    auto: "auto",
    on: "开启",
    off: "关闭",
    full: "完整",
    stream: "流式",
    customOption: "{value}（自定义）",
    manual: "手动",
    autoThreshold: "自动阈值",
    overflowRetry: "溢出重试",
    timeoutRetry: "超时重试",
    tokenRange: "{before} 到 {after} 个令牌",
    tokensBefore: "之前 {count} 个令牌",
    tokenDeltaUnavailable: "令牌增量不可用",
    checkpoints: "{count} 个检查点",
    checkpoint: "{count} 个检查点",
    showSessionDetails: "显示 {count} 的会话详情",
    hideSessionDetails: "隐藏 {count} 的会话详情",
    sessionDetails: "会话详情",
    overrides: "覆盖项",
    compactionHistory: "压缩历史记录",
    status: "状态",
    statusLive: "实时",
    statusIdle: "空闲",
    statusUnknown: "未知",
    statusRunning: "运行中",
    statusDone: "已完成",
    statusFailed: "失败",
    statusKilled: "已终止",
    statusTimeout: "已超时",
    model: "模型",
    provider: "提供商",
    runtime: "运行时",
    surface: "界面",
    subject: "主题",
    room: "房间",
    space: "空间",
    sessionId: "会话 ID",
    activeRun: "活动运行",
    archived: "已归档",
    pinned: "已置顶",
    unread: "未读",
    renameSession: "重命名会话",
    renameSessionPrompt: "重命名会话",
    renameSessionMenu: "重命名…",
    pinSession: "置顶会话",
    unpinSession: "取消置顶会话",
    markUnread: "标为未读",
    markRead: "标为已读",
    forkSession: "分叉",
    archiveSession: "归档会话",
    restoreSession: "恢复会话",
    deleteSessionMenu: "删除…",
    deleteSessionConfirm: "删除“{session}”及其转录记录？",
    groupBy: "分组依据",
    groupByNone: "无",
    groupByCategory: "自定义分组",
    groupByChannel: "渠道",
    groupByKind: "类型",
    groupByAgent: "代理",
    groupByDate: "日期",
    group: "分组",
    ungrouped: "未分组",
    newGroup: "新建分组…",
    newGroupPrompt: "新分组名称",
    moveToGroup: "将会话移动到分组",
    moveToGroupMenu: "移动到分组",
    removeFromGroup: "移出分组",
    groupMenu: "{group} 的分组选项",
    renameGroupMenu: "重命名分组…",
    renameGroupPrompt: "重命名分组",
    deleteGroupMenu: "删除分组…",
    deleteGroupConfirm: "要删除分组“{group}”吗？其会话将移至未分组。",
    dragSessionHint: "拖动以在分组之间移动",
    dateToday: "今天",
    dateYesterday: "昨天",
    dateThisWeek: "本周",
    dateOlder: "更早",
    dateNoActivity: "无活动",
    groupRowCount: "{count} 个会话",
    groupRowCountOne: "{count} 个会话",
    loadingCheckpoints: "正在加载检查点…",
    noCheckpoints: "此会话没有记录压缩检查点。",
    noSummary: "未捕获摘要。",
    branchFromCheckpoint: "从检查点创建分支",
    restoreCheckpoint: "恢复检查点",
  },
  agents: {
    noAgents: "无代理",
    copyId: "复制 ID",
    copyIdTitle: "将代理 ID 复制到剪贴板",
    default: "默认",
    setDefault: "设为默认",
    alreadyDefaultTitle: "已是默认代理",
    setDefaultTitle: "设为默认代理",
    selectTitle: "选择代理",
    selectSubtitle: "选择代理以查看其工作区和工具。",
    tabs: {
      overview: "概览",
      files: "文件",
      tools: "工具",
      skills: "技能",
      channels: "频道",
      cronJobs: "Cron Jobs",
    },
    context: {
      title: "代理上下文",
      workspace: "工作区",
      openFilesTab: "打开文件标签",
      primaryModel: "主模型",
      runtime: "运行时",
      thinkingDefault: "默认思考级别",
      identityName: "身份名称",
      identityAvatar: "身份头像",
      skillsFilter: "技能筛选器",
      default: "默认",
      configurationSubtitle: "工作区、身份和模型配置。",
      schedulingSubtitle: "工作区和调度目标。",
    },
    channels: {
      title: "频道",
      subtitle: "Gateway 全局频道状态快照。",
      lastRefresh: "上次刷新：{time}",
      loadHint: "加载频道以查看实时状态。",
      empty: "未找到频道。",
      connectedCount: "{connected}/{total} 已连接",
      noAccounts: "无账户",
      configuredCount: "已配置 {count} 个",
      notConfigured: "未配置",
      enabledCount: "已启用 {count} 个",
      setupGuide: "设置指南",
    },
    cronPanel: {
      schedulerTitle: "调度器",
      schedulerSubtitle: "Gateway 定时任务状态。",
      jobs: "任务",
      nextWake: "下次唤醒",
      agentJobsTitle: "代理定时任务",
      agentJobsSubtitle: "面向此代理的计划任务。",
      noJobs: "未分配任务。",
      runNow: "立即运行",
    },
    files: {
      emptyDraft: "空草稿",
      minRead: "{count} 分钟阅读",
      markdownPreview: "Markdown 预览",
      extensionPreview: "{ext} 预览",
      preview: "预览",
      expandPreview: "展开预览",
      collapsePreview: "收起预览",
      editFile: "编辑文件",
      closePreview: "关闭预览",
      coreFilesTitle: "核心文件",
      coreFilesSubtitle: "引导人格、身份和工具指引。",
      workspace: "工作区",
      loadHint: "加载代理工作区文件以编辑核心指令。",
      empty: "未找到文件。",
      missing: "缺失",
      selectFile: "选择要编辑的文件。",
      previewMarkdownTitle: "预览渲染后的 Markdown",
      willCreateOnSave: "保存时将创建",
      liveDraftPreview: "实时草稿预览",
      savedPreview: "已保存预览",
      updated: "更新于 {time}",
      notCreatedYet: "尚未创建",
      updatedUnknown: "更新时间未知",
      missingHint: "此文件缺失。保存后将在代理工作区中创建它。",
      content: "内容",
      words: "{count} 个词",
      lines: "行",
    },
  },
  debug: {
    snapshotsTitle: "快照",
    snapshotsSubtitle: "状态、健康状况和心跳数据。",
    status: "状态",
    health: "健康状况",
    lastHeartbeat: "上次心跳",
    security: {
      audit: "安全审计",
      critical: "{count} 个严重问题",
      warnings: "{count} 个警告",
      noCriticalIssues: "无严重问题",
      info: "{count} 条信息",
      runPrefix: "运行",
      runSuffix: "查看详情。",
    },
    manualRpcTitle: "手动 RPC",
    manualRpcSubtitle: "发送带 JSON 参数的原始 Gateway 方法。",
    method: "方法",
    selectMethod: "选择方法…",
    paramsJson: "参数 (JSON)",
    modelsTitle: "模型",
    modelsSubtitle: "来自 models.list 的目录。",
    eventLogTitle: "事件日志",
    eventLogSubtitle: "最新 Gateway 事件。",
    noEvents: "暂无事件。",
  },
  quickSettings: {
    security: {
      browserEnabled: "浏览器工具",
      toolProfile: "工具权限档位",
    },
  },
  execApproval: {
    expiresIn: "{time} 后过期",
    expired: "已过期",
    execApprovalNeeded: "需要 Exec 审批",
    pluginApprovalNeeded: "需要插件审批",
    pending: "{count} 个待处理",
    allowOnce: "允许一次",
    alwaysAllow: "始终允许",
    allowAlwaysUnavailable: "有效的批准策略要求每次都批准，因此“始终允许”不可用。",
    deny: "拒绝",
    labels: {
      host: "主机",
      agent: "代理",
      session: "会话",
      cwd: "CWD",
      resolved: "已解析",
      security: "安全",
      ask: "询问策略",
      severity: "严重性",
      plugin: "插件",
    },
  },
  agentTools: {
    connectedSource: "已连接：{id}",
    connected: "已连接",
    channelSource: "频道：{id}",
    channel: "渠道",
    builtIn: "内置",
  },
  nav: {
    chat: "聊天",
    settings: "设置",
    expand: "展开侧边栏",
    collapse: "折叠侧边栏",
    resize: "调整侧边栏大小",
    more: "更多",
    customize: "自定义侧边栏",
    customizeReset: "恢复默认设置",
  },
  terminal: {
    title: "终端",
    toggle: "切换终端",
    open: "打开终端",
    hide: "隐藏终端",
    resize: "调整终端面板大小",
    newSession: "新建终端会话",
    closeSession: "关闭终端会话",
    starting: "正在启动终端…",
    tabLabel: "Shell {n}",
    tabHint: "{agent} · {cwd}",
    exited: "已退出",
    exitedCode: "已退出（{code}）",
    detached: "已分离",
    dockBottom: "停靠到底部",
    dockRight: "停靠到右侧",
    unavailable: "此网关不可用终端。",
  },
  tabs: {
    agents: "代理",
    activity: "活动",
    overview: "概览",
    workboard: "工作板",
    worktrees: "工作树",
    channels: "频道",
    instances: "实例",
    sessions: "会话",
    usage: "使用情况",
    cron: "定时任务",
    tasks: "任务",
    skills: "技能",
    skillWorkshop: "技能工坊",
    nodes: "节点",
    chat: "聊天",
    config: "配置",
    communications: "通信",
    appearance: "外观与设置",
    automation: "自动化",
    mcp: "工具服务",
    infrastructure: "基础设施",
    aiAgents: "智能与代理",
    debug: "调试",
    logs: "日志",
    dreams: "梦境",
    plugin: "插件",
  },
  subtitles: {
    agents: "工作区、工具、身份。",
    activity: "浏览器本地工具活动摘要。",
    overview: "状态、入口点、健康。",
    workboard: "智能体工作队列和会话交接。",
    worktrees: "隔离的代理任务检出和恢复快照。",
    channels: "频道和设置。",
    instances: "已连接客户端和节点。",
    sessions: "活动会话和默认设置。",
    usage: "API 使用情况和成本。",
    cron: "唤醒和重复运行。",
    tasks: "后台任务：子代理、cron 运行、CLI。",
    skills: "技能和 API 密钥。",
    skillWorkshop: "在提案成为上线技能之前，进行审查、优化并应用。",
    nodes: "配对设备和命令。",
    chat: "网关聊天，快速干预。",
    config: "编辑配置文件。",
    communications: "频道、消息和音频设置。",
    appearance: "主题、界面和设置向导设置。",
    automation: "命令、钩子、定时任务和插件设置。",
    mcp: "工具服务、身份验证、工具和诊断。",
    infrastructure: "网关、网页服务、浏览器和媒体设置。",
    aiAgents: "代理、模型、技能、工具、记忆和会话设置。",
    debug: "快照、事件、RPC。",
    logs: "实时网关日志。",
    dreams: "睡眠时进行记忆巩固。",
    plugin: "插件提供的面板。",
  },
  tasksPage: {
    active: "活跃",
    recent: "最近",
    loading: "正在加载任务…",
    empty: "还没有后台任务。",
    emptyActive: "没有排队或正在运行的任务。",
    emptyRecent: "没有最近完成的任务。",
    disconnected: "连接到 Gateway 以加载和管理任务。",
    loadFailed: "无法加载任务。",
    cancelFailed: "无法取消该任务。",
    invalidResponse: "Gateway 返回了无效的任务列表。",
    untitled: "后台任务",
    taskCount: "{count} 个任务",
    taskCountOne: "1 个任务",
    agent: "代理：{agent}",
    openSession: "打开会话",
    cancelTask: "取消 {title}",
    cancelling: "正在取消…",
    status: {
      queued: "已排队",
      running: "运行中",
      completed: "已完成",
      failed: "失败",
      cancelled: "已取消",
      timedOut: "已超时",
    },
    runtime: {
      subagent: "子代理",
      cron: "Cron",
      acp: "ACP",
      cli: "CLI",
      unknown: "任务",
    },
  },
  skillWorkshop: {
    header: {
      useCurrentChat: "使用当前聊天",
      useCurrentChatAria: "将当前聊天用于修订请求",
      useCurrentChatTooltip: "将修订请求发送到当前聊天会话，而不是提案的工作坊会话。",
    },
  },
  activity: {
    title: "活动",
    subtitle: "从实时会话事件派生的临时工具活动。",
    visibleCount: "{visible} / {total}",
    filtersLabel: "活动筛选器",
    search: "搜索",
    searchPlaceholder: "按工具、摘要、运行、会话筛选",
    toolFilter: "工具",
    allTools: "所有工具",
    statusFilters: "状态筛选器",
    autoFollow: "自动跟随",
    expandAll: "全部展开",
    collapseAll: "全部折叠",
    clear: "清除",
    empty: "暂无工具活动。",
    emptyFiltered: "没有符合这些筛选条件的活动。",
    entrySummary: "{argumentSummary}",
    argumentHiddenOne: "已隐藏 1 个参数",
    argumentsHidden: "已隐藏 {count} 个参数",
    streamLabel: "工具活动条目",
    toolCallId: "工具调用",
    runId: "运行",
    session: "会话",
    outputTruncated: "预览已隐藏并截断。",
    noOutputPreview: "无输出预览。",
    status: {
      running: "运行中",
      done: "已完成",
      error: "错误",
    },
    duration: {
      ms: "{count} ms",
      seconds: "{count} s",
      minutes: "{minutes}m {seconds}s",
    },
  },
  logsView: {
    title: "日志",
    subtitle: "网关文件日志（JSONL）。",
    exportButton: "导出{label}",
    exportLabels: {
      filtered: "已筛选",
      visible: "可见",
    },
    filter: "筛选",
    searchPlaceholder: "搜索日志",
    autoFollow: "自动跟随",
    file: "文件：{file}",
    truncated: "日志输出已截断；正在显示最新片段。",
    empty: "暂无日志条目。",
  },
  pluginTabs: {
    unavailableTitle: "插件面板不可用",
    unavailableSubtitle:
      "The plugin that owns this tab is not active on the connected gateway, or it did not provide a panel.",
  },
  logbook: {
    duration: {
      minutes: "{minutes}m",
      hours: "{hours}h {minutes}m",
    },
    nav: {
      previousDay: "Previous day",
      nextDay: "Next day",
      today: "Today",
    },
    status: {
      capturing: "Capturing every {seconds}s",
      paused: "Capture paused",
      disabled: "Capture off",
      nodeHelp: "Node providing screen snapshots.",
      pending: "{count} frames queued",
      pendingHelp: "Snapshots waiting for the next analysis batch.",
      analyzing: "Analyzing…",
      captureError: "Capture error",
      batchError: "Analysis error",
      modelMissing: "No vision model",
      modelMissingHelp:
        "Set plugins.entries.logbook.config.visionModel (for example codex/gpt-5.5) or configure tools.media models.",
    },
    actions: {
      pause: "Pause",
      resume: "Resume",
      analyzeNow: "Analyze now",
    },
    empty: {
      title: "Nothing on the timeline yet.",
      subtitle:
        "Logbook is collecting snapshots; cards appear after the first analysis batch completes.",
    },
    card: {
      keyframeAlt: "Screen snapshot from this activity",
      distractions: "Distractions",
    },
    stats: {
      title: "Day at a glance",
      focus: "{pct}% focus",
      tracked: "{duration} tracked",
    },
    standup: {
      title: "Daily standup",
      generate: "Generate",
      refresh: "Regenerate",
      empty: "Turn today's timeline into a ready-to-paste standup update.",
    },
    ask: {
      title: "Ask your day",
      placeholder: "When did I review the gateway PR?",
      submit: "Ask",
    },
  },
  workboard: {
    disabledHelpStart: "Workboard 已禁用。启用",
    enableConfigKey: "plugins.entries.workboard.enabled = true",
    disabledHelpEnd: "，然后重新加载此标签页。",
    status: {
      triage: "Triage",
      backlog: "待办池",
      todo: "待办",
      scheduled: "已计划",
      ready: "就绪",
      running: "运行中",
      review: "查看",
      blocked: "已阻挡",
      done: "已完成",
    },
    noLinkedSession: "没有已关联的会话",
    stopSession: "停止会话",
    editCard: "编辑卡片",
    editCardHelp: "更新队列元数据和会话交接。",
    newCard: "新建卡片",
    newCardHelp: "为代理会话排队工作。",
    archiveCard: "归档卡片",
    unarchiveCard: "Restore from archive",
    archived: "Archived",
    deleteCard: "删除卡片",
    viewDetails: "查看详情",
    detailTitle: "卡片详情",
    detailTask: "Gateway 任务",
    detailRun: "运行",
    detailUpdated: "已更新",
    detailProof: "凭证",
    detailDiagnostics: "诊断",
    detailWorkerLogs: "Worker 日志",
    detailWorkerProtocol: "Worker 协议",
    detailAutomation: "自动化",
    detailUpdatedValue: "已更新：{time}",
    detailAutomationTenant: "租户：{tenant}",
    detailAutomationBoard: "看板：{board}",
    detailAutomationSkills: "Skills：{skills}",
    detailAutomationWorkspace: "工作区：{workspace}",
    detailAutomationSummary: "摘要：{summary}",
    detailOperatorNotes: "操作员备注",
    detailNoNotes: "暂无操作员备注。",
    detailNotePlaceholder: "添加决策、阻碍或证明备注……",
    detailAddNote: "添加备注",
    openSession: "打开会话",
    openLinkedSession: "打开关联会话",
    defaultAgent: "默认代理",
    allAgents: "All agents",
    agentFilter: "Filter by agent",
    agentFilterUnassigned: "未分配（使用 {agent}）",
    agentFilterUnassignedHelp: "未明确指定 agent 的卡片。",
    agentFilterConfiguredDefault: "{agent}（默认）",
    agentFilterConfiguredDefaultHelp: "明确分配给已配置默认 agent 的卡片。",
    agentCurrentUnconfigured: "{agent}（未配置）",
    viewPreset: "工作板视图",
    viewAll: "全部卡片",
    viewDefaultAgent: "默认 agent",
    viewReady: "就绪",
    viewRunning: "运行中",
    viewBlocked: "已阻塞",
    viewReview: "审核",
    viewStale: "已过时",
    viewMissingProof: "缺少凭证",
    viewRecentlyDone: "最近完成",
    viewPresetCount: "{count} 张卡片",
    agentLinked: "Linked to {agent}",
    agentDefaultLinked: "Using default agent {agent}",
    engineOpenAI: "OpenAI",
    engineClaude: "Claude",
    engineDisabledRuntime:
      "{agent} uses the {runtime} ACP runtime. Use default start for that session.",
    runEngine: "运行 {engine}",
    openEngine: "打开 {engine}",
    runDefaultAgent: "运行默认代理",
    run: "Run",
    open: "Open",
    start: "开始",
    dependencies: "依赖项",
    dependenciesReady: "{count} 项就绪",
    dependenciesReadyTitle: "{count} 个依赖项已完成。",
    dependenciesBlocked: "{count} 项受阻",
    dependenciesBlockedTitle: "正在等待依赖项：{parents}。",
    dependencyMissing: "{parent}（缺失）",
    dependencyStatusMissing: "缺失",
    unknownStatus: "未知",
    showArchived: "Show archived cards",
    hideArchived: "Hide archived cards",
    showArchivedShort: "Archived",
    hideArchivedShort: "Hide archived",
    layout: "Card layout",
    layoutCompact: "紧凑卡片密度",
    layoutComfortable: "宽松卡片密度",
    dispatch: "提醒调度器",
    dispatchSummary:
      "Dispatch complete: started {started}, promoted {promoted}, blocked {blocked}, reclaimed {reclaimed}, orchestrated {orchestrated}, failures {failures}.",
    dispatchSummaryEmpty: "Dispatch complete: no ready work changed.",
    autoRefresh: "自动刷新",
    autoRefreshOff: "关闭",
    autoRefresh5s: "5秒",
    autoRefresh15s: "15秒",
    autoRefresh30s: "30秒",
    autoRefresh60s: "60秒",
    lastRefreshed: "已更新 {time}",
    refreshError: "刷新失败",
    healthLabel: "工作板健康状况",
    healthRunning: "运行中",
    healthBlocked: "已阻塞",
    healthStale: "已过期",
    healthReadyUnassigned: "就绪未分配",
    healthMissingProof: "缺少凭证",
    healthFailedAttempts: "失败尝试",
    ageHours: "{count}小时",
    live: "实时",
    fieldTitle: "标题",
    fieldNotes: "备注",
    fieldStatus: "状态",
    fieldPriority: "优先级",
    fieldAgent: "代理",
    fieldSession: "会话",
    fieldLabels: "标签",
    templatesLabel: "卡片模板",
    template: {
      bugfix: "Bugfix",
      docs: "Docs",
      release: "Release",
      pr_review: "PR review",
      plugin: "Plugin",
    },
    badgeAttempts: "{count} 次尝试",
    badgeFailures: "{count} 次失败",
    badgeComments: "{count} 条评论",
    badgeLinks: "{count} 个链接",
    badgeProof: "{count} 个证明",
    badgeHeartbeat: "心跳 {age}",
    badgeArtifacts: "{count} 个产物",
    badgeAttachments: "{count} 个附件",
    badgeWorkerLogs: "{count} 条 worker 日志",
    badgeWorkerProtocol: "worker {state}",
    badgeTenant: "租户 {tenant}",
    badgeSkills: "{count} 个技能",
    badgeDispatches: "{count} 次调度",
    badgeTaskLinked: "task linked",
    badgeClaimed: "由 {owner} 认领",
    badgeDiagnostics: "{count} 个诊断",
    badgeStale: "已过期",
    titlePlaceholder: "卡片标题",
    notesPlaceholder: "备注、验收标准、链接",
    labelsPlaceholder: "ui, docs",
    searchPlaceholder: "搜索卡片",
    allPriorities: "所有优先级",
    hideEmptyColumns: "Hide empty columns",
    emptyColumn: "将工作拖放到此处",
    emptyFilteredTitle: "没有卡片符合此视图",
    emptyFilteredHint: "请更改视图、搜索、优先级、代理或归档筛选条件。",
    lifecycleUnlinked: "无会话",
    lifecycleUnlinkedDetail: "启动或关联会话",
    lifecycleMissing: "会话缺失",
    lifecycleMissingDetail: "重新加载会话或重新关联此卡片",
    lifecycleLinked: "已关联",
    lifecycleIdleDetail: "无活动运行",
    lifecycleRunning: "运行中",
    lifecycleRunningDetail: "活动运行正在进行",
    lifecycleStale: "已过期",
    lifecycleStaleDetail: "最近没有会话活动",
    lifecycleDone: "已完成",
    lifecycleDoneDetail: "已移至审核",
    lifecycleNeedsReview: "需要审核",
    lifecycleNeedsReviewDetail: "运行已停止或失败",
    taskStatus: {
      queued: "Task queued",
      running: "Task running",
      completed: "Task complete",
      failed: "Task failed",
      cancelled: "Task cancelled",
      timed_out: "Task timed out",
    },
    eventsLabel: "卡片事件",
    eventCreated: "已创建",
    eventEdited: "已编辑",
    eventMoved: "已移动",
    eventMovedTo: "已移至 {status}",
    eventLinked: "已关联会话",
    eventSpecified: "Specified",
    eventDecomposed: "Decomposed",
    eventClaimed: "已认领",
    eventHeartbeat: "心跳",
    eventExecutionUpdated: "Agent 已更新",
    eventAttemptStarted: "尝试已开始",
    eventAttemptUpdated: "尝试已更新",
    eventCommentAdded: "评论已添加",
    eventLinkAdded: "链接已添加",
    eventProofAdded: "证明已添加",
    eventArtifactAdded: "产物已添加",
    eventAttachmentAdded: "已添加附件",
    eventDiagnostic: "诊断",
    eventNotification: "通知",
    eventDispatch: "调度",
    eventOrchestration: "编排",
    eventProtocolViolation: "协议违规",
    eventArchived: "已归档",
    eventUnarchived: "已取消归档",
    eventStale: "过期会话",
  },
  overview: {
    access: {
      title: "网关访问",
      subtitle: "仪表板连接的位置及其身份验证方式。",
      wsUrl: "网关连接地址",
      token: "网关令牌",
      password: "密码（不存储）",
      passwordPlaceholder: "可选",
      sessionKey: "默认会话",
      language: "语言",
      connectHint: "点击连接以应用连接更改。",
      trustedProxy: "通过受信任代理认证。",
      showToken: "显示令牌",
      hideToken: "隐藏令牌",
      toggleTokenVisibility: "切换令牌可见性",
      showPassword: "显示密码",
      hidePassword: "隐藏密码",
      togglePasswordVisibility: "切换密码可见性",
    },
    snapshot: {
      title: "快照",
      subtitle: "最新的网关握手信息。",
      status: "状态",
      uptime: "运行时间",
      tickInterval: "刻度间隔",
      lastChannelsRefresh: "最后频道刷新",
      channelsHint: "使用频道连接微信、企业微信或其他消息渠道。",
    },
    stats: {
      instances: "实例",
      instancesHint: "过去 5 分钟内的在线信号。",
      sessions: "会话",
      sessionsHint: "网关跟踪的最近会话密钥。",
      cron: "定时任务",
      cronNext: "下次唤醒 {time}",
    },
    notes: {
      title: "备注",
      subtitle: "远程控制设置的快速提醒。",
      tailscaleTitle: "Tailscale 服务",
      tailscaleText: "首选 serve 模式以通过 tailnet 身份验证将网关保持在回环地址。",
      sessionTitle: "会话清理",
      sessionText: "使用 /new 或 sessions.patch 重置上下文。",
      cronTitle: "定时任务提醒",
      cronText: "为重复运行使用隔离的会话。",
    },
    auth: {
      required: "此网关需要身份验证。添加令牌或密码，然后点击连接。",
      failed: "身份验证失败。请使用 {command} 重新复制带令牌的链接，或更新令牌，然后点击连接。",
    },
    pairing: {
      hint: "此设备需要网关主机的配对批准。",
      scopeUpgradeTitle: "范围升级等待批准。",
      scopeUpgradeSummary: "此设备已配对，但请求的更广范围仍在等待批准。",
      roleUpgradeTitle: "角色升级等待批准。",
      roleUpgradeSummary: "此设备已配对，但请求的角色变更仍在等待批准。",
      metadataUpgradeTitle: "设备元数据更改等待批准。",
      metadataUpgradeSummary: "此设备已配对，但元数据更改仍在等待批准。",
      mobileHint:
        "在手机上？从桌面运行 openclaw dashboard --no-open 复制完整 URL（包括 #token=...）。",
      docsTitle: "设备配对文档（在新标签页中打开）",
      docsLink: "文档：设备配对",
    },
    insecure: {
      hint: "此页面为 HTTP，因此浏览器阻止设备标识。请使用 HTTPS (Tailscale Serve) 或在网关主机上打开 {url}。",
      stayHttp: "如果您必须保持 HTTP，请设置 {config} (仅限令牌)。",
    },
    connection: {
      title: "如何连接",
      step1: "在主机上启动网关：",
      step2: "获取带令牌的仪表盘链接：",
      step3: "将网关连接地址和令牌粘贴到上方，或直接打开带令牌的链接。",
      step4: "或生成可重复使用的令牌：",
      docsHint: "如需远程访问，建议使用 Tailscale Serve。",
      docsLink: "查看文档",
      authDocsTitle: "Control UI 身份验证文档（在新标签页中打开）",
      authDocsLink: "文档：Control UI 身份验证",
      tailscaleDocsTitle: "Tailscale Serve 文档（在新标签页中打开）",
      tailscaleDocsLink: "文档：Tailscale Serve",
      insecureHttpDocsTitle: "不安全 HTTP 文档（在新标签页中打开）",
      insecureHttpDocsLink: "文档：不安全 HTTP",
      copyCommand: "复制命令",
      copyCommandAria: "复制命令：{command}",
    },
    cards: {
      cost: "成本",
      skills: "技能",
      recentSessions: "最近会话",
      modelAuth: "模型认证",
      modelAuthOk: "{count} 正常",
      modelAuthExpired: "{count} 已过期",
      modelAuthExpiring: "{count} 即将过期",
      modelAuthProviders: "{count} 个提供商",
      modelAuthUsageLeft: "剩余 {pct}%",
      modelAuthExpiresIn: "于 {when} 过期",
      modelAuthAttentionExpiredTitle: "模型认证已过期",
      modelAuthAttentionExpiringTitle: "模型认证即将过期",
      modelAuthAttentionExpiredDesc: "{providers} — 使用 openclaw models auth 重新认证",
      modelAuthAttentionExpiringEntry: "{provider}（{when}）",
    },
    attention: {
      title: "注意事项",
    },
    eventLog: {
      title: "事件日志",
    },
    logTail: {
      title: "网关日志",
    },
    quickActions: {
      newSession: "新建会话",
      automation: "自动化",
      refreshAll: "全部刷新",
      terminal: "终端",
    },
    palette: {
      placeholder: "输入命令…",
      noResults: "无结果",
      categories: {
        search: "搜索",
        navigation: "导航",
        skills: "技能",
      },
      items: {
        overview: "概览",
        sessions: "会话",
        scheduled: "已计划",
        skills: "技能",
        settings: "设置",
        agents: "代理",
        shellCommand: "Shell 命令",
        debugMode: "调试模式",
      },
      descriptions: {
        shellCommand: "运行 shell",
        debugMode: "切换调试",
      },
      footer: {
        navigate: "导航",
        select: "选择",
        close: "关闭",
      },
    },
  },
  dreaming: {
    agentSelect: {
      label: "代理",
      ariaLabel: "Dreaming agent",
    },
    tabs: {
      scene: "场景",
      diary: "日记",
      advanced: "高级",
    },
    header: {
      refresh: "刷新",
      refreshing: "刷新中…",
      on: "Dreaming 已开启",
      off: "Dreaming 已关闭",
    },
    restartConfirmation: {
      title: "Restart Gateway to Apply Change",
      subtitle: "Changing Dreaming mode restarts the gateway.",
      warning:
        "This action will restart the Gateway and may temporarily interrupt chats, automations, and connected channels.",
      confirm: "Confirm Restart",
      restarting: "Restarting…",
      failed: "Could not apply change. Check your connection and try again.",
    },
    status: {
      active: "Dreaming 运行中",
      idle: "Dreaming 空闲",
      promotedSuffix: "已提升",
      nextSweepPrefix: "下次扫描",
    },
    scene: {
      backfill: "回填",
      dedupeDiary: "去重日记",
      reset: "重置",
      clearGrounded: "清除已落地",
      repairCache: "修复梦境缓存",
      working: "处理中…",
    },
    phase: {
      light: "浅睡",
      deep: "深睡",
      rem: "REM",
      off: "关闭",
    },
    advanced: {
      eyebrow: "查看",
      title: "每日日志回顾",
      description: "查看每日日志中的内容、等待提升的内容，以及最近已提升的内容。",
      summaryFromDailyLog: "来自每日日志",
      summaryWaiting: "等待中",
      summaryPromotedToday: "今日已提升",
      stagedTitle: "来自每日日志",
      stagedDescription: "从较早的每日日志条目中提取的重放候选项。",
      shortTermTitle: "等待提升",
      shortTermDescription: "当前等待升级为真实记忆的短期候选项。",
      sortRecent: "最新",
      sortSignals: "支持度最高",
      originDailyLog: "重放",
      originLive: "实时",
      originMixed: "混合",
      promotedTitle: "最近提升",
      promotedDescription: "已经完成提升的条目。",
      emptyGrounded: "当前没有已暂存的 grounded 重放条目。",
      emptyShortTerm: "没有可查看的短期条目。",
      emptyPromoted: "没有可查看的最近提升条目。",
      updatedPrefix: "更新于",
    },
    stats: {
      shortTerm: "短期",
      grounded: "已落地",
      signals: "信号",
      promoted: "已提升",
      phaseHits: "阶段命中",
    },
    trace: {
      shortTerm: "短期",
      grounded: "已落地",
      signals: "信号",
      promoted: "已提升",
      groundedLed: "grounded-led",
      emptyShortTerm: "当前没有活跃的短期项目。",
      emptyGrounded: "没有暂存的已落地项目。",
      emptySignals: "当前没有活跃的信号。",
      emptyPromoted: "今天还没有任何提升内容。",
    },
    diary: {
      title: "梦境日记",
      noDreamsYet: "尚无梦境",
      noDreamsHint: "首次梦境周期运行后，梦境会显示在这里。",
      waitingTitle: "日记正在等待",
      waitingHint: "下一次梦境周期后将显示叙事条目。",
      older: "较早",
      newer: "较新",
      reload: "重新加载",
      reloading: "重新加载中…",
    },
    phrases: {
      consolidatingMemories: "正在整合记忆…",
      tidyingKnowledgeGraph: "正在整理知识图谱…",
      replayingConversations: "正在重放今天的对话…",
      weavingShortTerm: "正在将短期记忆编织进长期记忆…",
      defragmentingMindPalace: "正在整理心智宫殿的碎片…",
      filingLooseThoughts: "正在归档零散思绪…",
      connectingDots: "正在连接遥远的线索…",
      compostingContext: "正在将旧上下文窗口化作养分…",
      alphabetizingSubconscious: "正在为潜意识按字母排序…",
      promotingHunches: "正在提升有希望的直觉…",
      forgettingNoise: "正在遗忘无关紧要的噪音…",
      dreamingEmbeddings: "正在 embeddings 中做梦…",
      reorganizingAttic: "正在重新整理记忆阁楼…",
      indexingDay: "正在轻轻索引这一天…",
      nurturingInsights: "正在培育初现的洞见…",
      simmeringIdeas: "正在酝酿尚未成形的想法…",
      whisperingVectorStore: "正在向向量存储轻声低语…",
    },
  },
  usage: {
    common: {
      emptyValue: "—",
      unknown: "未知",
    },
    loading: {
      title: "使用概览",
      badge: "加载中",
    },
    metrics: {
      tokens: "Token",
      cost: "成本",
      session: "会话",
      sessions: "会话",
    },
    providerUsage: {
      title: "供应商套餐与计费",
      subtitle: "已配置供应商报告的实时套餐、配额、余额和预算数据。",
      balance: "余额",
      spend: "用量",
      budget: "预算",
      today: "今天",
      last7Days: "7 天",
      lastDays: "{count} 天",
      dailyCost: "每日提供商费用",
      requests: "{count} 个请求",
      inputTokens: "{count} 个输入令牌",
      cacheTokens: "{count} 个缓存令牌",
      outputTokens: "{count} 个输出令牌",
      topModels: "热门模型",
      costCategories: "费用类别",
      remaining: "剩余 {percent}%",
      resets: "于 {date} 重置",
    },
    presets: {
      today: "今天",
      last7d: "7天",
      last30d: "30天",
      last90d: "90d",
      last1y: "1y",
      all: "全部",
    },
    scope: {
      instance: "当前实例",
      instanceHint: "仅显示每个逻辑会话的活跃会话 ID。",
      family: "历史谱系",
      familyHint: "汇总已知的轮换后、由转录记录支持的会话 ID。",
      familyIncluded: "历史谱系包含 {count} 个会话实例。",
    },
    filters: {
      title: "筛选",
      to: "至",
      startDate: "开始日期",
      endDate: "结束日期",
      timeZone: "时区",
      timeZoneLocal: "本地",
      timeZoneUtc: "UTC",
      pin: "固定",
      pinned: "已固定",
      unpin: "取消固定筛选",
      selectAll: "全选",
      clear: "清除",
      clearAll: "全部清除",
      remove: "移除筛选",
      all: "全部",
      days: "天",
      hours: "小时",
      session: "会话",
      agent: "代理",
      channel: "渠道",
      provider: "提供商",
      model: "模型",
      tool: "工具",
      daysCount: "{count} 天",
      hoursCount: "{count} 小时",
      sessionsCount: "{count} 个会话",
    },
    query: {
      placeholder: "筛选会话（例如 key:agent:main:cron* model:gpt-4o has:errors minTokens:2000）",
      apply: "筛选（客户端）",
      matching: "匹配 {shown} / {total} 个会话",
      inRange: "范围内有 {total} 个会话",
      tip: "提示：使用筛选器或点击条形图来细化日期。",
    },
    export: {
      label: "导出",
      sessionsCsv: "会话 CSV",
      dailyCsv: "每日 CSV",
      json: "JSON",
    },
    cacheStatus: {
      warning: "用量缓存正在后台重建。显示的总计可能不是最新的。",
      title: "{status}: {pending} 个待处理，{stale} 个过期，{cached} 个已缓存",
      status: {
        refreshing: "正在刷新",
        stale: "过期",
        partial: "部分",
      },
    },
    empty: {
      title: "从日期范围开始",
      subtitle: "加载使用数据以比较成本、检查会话，并深入查看时间线，无需离开仪表板。",
      hint: "选择日期范围并点击“刷新”以加载使用情况。",
      noData: "无数据",
      featureOverview: "概览卡片",
      featureSessions: "会话排名",
      featureTimeline: "时间线钻取",
    },
    daily: {
      title: "每日使用情况",
      total: "总计",
      byType: "按类型",
      tokensTitle: "每日 Token 使用量",
      costTitle: "每日成本",
      compressedScaleHint: "平方根刻度可让低用量日期保持可见。",
    },
    costWindows: {
      title: "费用周期",
      subtitle: "截至 {date} 的日历周期",
      selectedRange: "所选范围",
      lastDays: "过去 {count} 天",
      perDay: "/ 天",
    },
    breakdown: {
      output: "输出",
      input: "输入",
      cacheWrite: "缓存写入",
      cacheRead: "缓存读取",
      total: "总计",
      tokensByType: "按类型划分的 Token",
      costByType: "按类型划分的成本",
    },
    overview: {
      title: "使用概览",
      messages: "消息",
      messagesHint: "范围内用户和助手消息总数。",
      messagesAbbrev: "消息",
      user: "用户",
      assistant: "助手",
      toolCalls: "工具调用",
      toolCallsHint: "跨会话的工具调用总次数。",
      toolsUsed: "已使用工具",
      errors: "错误",
      errorsHint: "范围内消息和工具错误总数。",
      toolResults: "工具结果",
      avgTokens: "平均 Token / 消息",
      avgTokensHint: "此范围内每条消息的平均 Token 数。",
      avgCost: "平均成本 / 消息",
      avgCostHint: "当提供商报告成本时，每条消息的平均成本。",
      avgCostHintMissing:
        "当提供商报告成本时，每条消息的平均成本。此范围内部分或全部会话缺少成本数据。",
      acrossMessages: "共 {count} 条消息",
      sessions: "会话",
      sessionsHint: "范围内的不重复会话数。",
      sessionsInRange: "范围内共 {count} 个",
      throughput: "吞吐量",
      throughputHint: "吞吐量显示活跃时间内每分钟的 Token 数。越高越好。",
      tokensPerMinute: "tok/min",
      perMinute: "/ 分钟",
      errorRate: "错误率",
      errorHint: "错误率 = 错误数 / 消息总数。越低越好。",
      avgSession: "平均会话",
      cacheHitRate: "缓存命中率",
      cacheHint: "缓存命中率 = 缓存读取 /（输入 + 缓存读取）。越高越好。",
      cached: "已缓存",
      prompt: "提示",
      calls: "调用",
      costShare: "占费用的 {percent}%",
      topModels: "热门模型",
      topProviders: "热门提供商",
      topTools: "热门工具",
      topAgents: "热门代理",
      topChannels: "热门渠道",
      peakErrorDays: "错误高峰日",
      peakErrorHours: "错误高峰时段",
      noModelData: "无模型数据",
      noProviderData: "无提供商数据",
      noToolCalls: "无工具调用",
      noAgentData: "无代理数据",
      noChannelData: "无渠道数据",
      noErrorData: "无错误数据",
    },
    sessions: {
      title: "会话",
      shown: "已显示 {count} 个",
      total: "共 {count} 个",
      avg: "平均",
      all: "全部",
      recent: "最近查看",
      recentShort: "最近",
      sort: "排序",
      ascending: "升序",
      descending: "降序",
      clearSelection: "清除选择",
      noRecent: "没有最近会话",
      noneInRange: "范围内没有会话",
      more: "另有 +{count} 个",
      selected: "已选择（{count}）",
      copy: "复制",
      copyName: "复制会话名称",
      limitReached: "仅显示前 1,000 个会话。请缩小日期范围以查看完整结果。",
    },
    details: {
      noUsageData: "此会话没有使用数据。",
      duration: "时长",
      modelMix: "模型构成",
      filtered: "（已筛选）",
      close: "关闭会话详情",
      noTimeline: "无时间线数据",
      noDataInRange: "范围内无数据",
      usageOverTime: "使用趋势",
      reset: "重置",
      perTurn: "按轮次",
      cumulative: "累计",
      turnRange: "第 {start}–{end} 轮，共 {total} 轮",
      assistantOutputTokens: "助手输出 Token",
      userToolInputTokens: "用户 + 工具输入 Token",
      tokensWrittenToCache: "写入缓存的 Token",
      tokensReadFromCache: "从缓存读取的 Token",
      noContextData: "无上下文数据",
      systemPromptBreakdown: "系统提示词明细",
      collapse: "折叠",
      collapseAll: "全部折叠",
      expandAll: "全部展开",
      baseContextPerMessage: "每条消息的基础上下文",
      system: "系统",
      systemShort: "系统",
      skills: "技能",
      tools: "工具",
      files: "文件",
      ofInput: "占输入的",
      of: "占",
      timelineFiltered: "时间线已筛选",
      conversation: "对话",
      noMessages: "无消息",
      tool: "工具",
      toolResult: "工具结果",
      hasTools: "包含工具",
      searchConversation: "搜索对话",
      you: "你",
      noMessagesMatch: "没有消息符合筛选条件。",
    },
    mosaic: {
      title: "按时间查看活动",
      subtitleEmpty: "估算需要会话时间戳。",
      subtitle: "根据会话跨度（首次/最后活动）估算。时区：{zone}。",
      noTimelineData: "暂无时间线数据。",
      dayOfWeek: "星期",
      midnight: "午夜",
      fourAm: "凌晨 4 点",
      eightAm: "上午 8 点",
      noon: "中午",
      fourPm: "下午 4 点",
      eightPm: "晚上 8 点",
      legend: "低 → 高 Token 密度",
      sun: "周日",
      mon: "周一",
      tue: "周二",
      wed: "周三",
      thu: "周四",
      fri: "周五",
      sat: "周六",
    },
  },
  login: {
    subtitle: "网关仪表盘",
    passwordPlaceholder: "可选",
    showToken: "显示令牌",
    hideToken: "隐藏令牌",
    toggleTokenVisibility: "切换令牌可见性",
    showPassword: "显示密码",
    hidePassword: "隐藏密码",
    togglePasswordVisibility: "切换密码可见性",
    failure: {
      rawError: "原始错误",
      docsAuth: "控制台认证文档",
      docsPairing: "设备配对文档",
      docsInsecure: "不安全 HTTP 文档",
      authRequired: {
        title: "需要认证",
        summary: "网关可以访问，但此浏览器连接前需要匹配的令牌或密码。",
        stepPaste: "粘贴 openclaw dashboard --no-open 提供的令牌，或输入已配置的密码。",
        stepGenerate:
          "如果未配置令牌，请在网关主机上运行 openclaw doctor --generate-gateway-token。",
        stepConnect: "更新凭据后再次点击 Connect。",
      },
      authFailed: {
        title: "认证不匹配",
        summary: "提供的凭据被拒绝。最常见原因是令牌已过期，或令牌来自另一个网关 URL。",
        stepDashboard: "运行 openclaw dashboard --no-open 并打开新的 URL，或粘贴其中的令牌。",
        stepReplace: "替换过期的令牌/密码；不要复用另一个网关 URL 的令牌。",
        stepMode: "一次只使用一种匹配的认证模式：令牌模式使用 gateway token，密码模式使用密码。",
      },
      rateLimited: {
        title: "失败尝试过多",
        summary: "网关正在临时限制此客户端的认证尝试。",
        stepStop: "暂时停止从此标签页重试。",
        stepWait: "等待认证限制器冷却，然后使用修正后的凭据重新连接。",
        stepCheckClients: "如果这是共享主机，请检查其他客户端是否在重复错误重试。",
      },
      pairing: {
        title: "需要设备配对",
        scopeTitle: "Scope 升级待批准",
        roleTitle: "角色升级待批准",
        metadataTitle: "设备刷新待批准",
        summary: "此浏览器需要网关主机的一次性批准后才能使用控制台。",
        upgradeSummary: "此浏览器已知，但请求的访问权限已变更，需要重新批准。",
        stepList: "在网关主机上运行 openclaw devices list。",
        stepApproveId: "批准此请求：openclaw devices approve {requestId}。",
        stepApprove: "从该列表批准待处理的浏览器/设备请求。",
        stepReconnect: "批准完成后重新连接。",
      },
      insecure: {
        title: "需要安全浏览器上下文",
        summary: "此页面通过普通 HTTP 运行，因此浏览器无法创建网关期望的设备身份。",
        stepHttps: "使用 HTTPS/Tailscale Serve，或在网关主机上打开 http://127.0.0.1:18789。",
        stepLocalCompat: "如需本地仅令牌兼容，设置 gateway.controlUi.allowInsecureAuth: true。",
        stepAvoidDisable: "避免为远程 HTTP 访问禁用设备认证。",
      },
      origin: {
        title: "浏览器来源不被允许",
        summary: "网关在接受控制台连接前拒绝了此页面来源。",
        stepAllowedOrigins: "将此浏览器来源添加到 gateway.controlUi.allowedOrigins。",
        stepFullOrigin: "使用完整来源，例如 http://localhost:5173，不要使用通配符模式。",
        stepRestart: "更改允许来源后重启或重新加载网关。",
      },
      protocol: {
        title: "协议不匹配",
        summary: "提供的控制台与正在运行的网关对支持的连接协议不一致。",
        stepDashboard:
          "使用 openclaw dashboard 重新打开提供的控制台，确保界面和网关来自同一安装。",
        stepDevUi: "如果使用 pnpm ui:dev，请基于当前 checkout 重新构建或重启开发 UI。",
        stepRestart: "更新康桥集团AI助理后重启网关，使其提供当前协议。",
      },
      network: {
        title: "无法连接",
        summary: "浏览器无法完成网关连接。重试凭据前请检查目标和传输方式。",
        stepGateway: "使用 openclaw status 或 openclaw gateway run 确认网关正在运行。",
        stepUrl: "检查 WebSocket URL；当网关位于 HTTPS/Tailscale Serve 后面时使用 wss://。",
        stepDashboard:
          "使用 openclaw dashboard --no-open 重新打开 dashboard，以重新复制当前 URL 和认证详情。",
      },
    },
  },
  connection: {
    lostTitle: "网关连接已断开",
    reconnecting: "正在重新连接…",
    offlineHint: "实时更新和操作已暂停，直到连接恢复。",
    retryNow: "立即重试",
  },
  chat: {
    disconnected: "已断开与网关的连接。",
    archivedSessionDisabled: "恢复此会话以发送消息。",
    refreshTitle: "刷新聊天数据",
    settings: "聊天设置",
    usageRemaining: "剩余用量",
    voiceSettings: "语音",
    thinkingToggle: "切换助手思考/工作输出",
    toolCallsToggle: "切换工具调用和工具结果",
    commentaryToggle: "在最终答案后保留评述",
    commentaryLabel: "评述",
    autoScrollMode: "自动滚动模式",
    autoScrollAlways: "始终",
    autoScrollNearBottom: "接近底部",
    autoScrollOff: "关闭",
    sendShortcut: "发送快捷键",
    sendShortcutEnter: "Enter",
    sendShortcutModifierEnter: "⌘/Ctrl+Enter",
    hideCronSessions: "隐藏定时任务会话",
    showCronSessions: "显示定时任务会话",
    showCronSessionsHidden: "显示定时任务会话 (已隐藏 {count} 个)",
    onboardingDisabled: "引导期间禁用",
    gatewayStatus: "Gateway 状态：{status}",
    commandPaletteTitle: "搜索或跳转到… (⌘K)",
    openCommandPalette: "打开命令面板",
    docsOpensInNewTab: "{label}（在新标签页中打开）",
    updateAvailable: "有可用更新：",
    runningVersion: "正在运行 v{version}",
    updating: "正在更新…",
    updateNow: "立即更新",
    dismissUpdateBanner: "关闭更新横幅",
    switchedSession: "已切换到 {session}",
    splitView: {
      open: "打开拆分视图",
      splitRight: "向右拆分",
      splitDown: "向下拆分",
      closePane: "关闭窗格",
      sessionSelect: "窗格会话",
      dropSplit: "拆分",
      dropOpenHere: "在此处打开",
    },
    sidebar: {
      allSessions: "所有会话",
      openSessionMenu: "打开会话菜单",
      sortBy: "排序方式",
      sortCreated: "创建时间",
      sortSessions: "排序会话",
      sortUpdated: "最近更新",
      sessionMenu: "{session} 的操作",
    },
    welcome: {
      ready: "集团沟通助手已就绪",
      hintBeforeShortcut: "在下方输入需求 · 输入",
      hintAfterShortcut: "查看工具命令",
      suggestions: {
        whatCanYouDo: "生成一份集团通知草稿",
        summarizeRecentSessions: "整理学校反馈和待办",
        configureChannel: "起草微信公众号推送",
        checkSystemHealth: "检查系统健康状况",
      },
    },
    runControls: {
      newSession: "新会话",
      newSessionWorktree: "在工作树中新建聊天",
      export: "导出",
      exportChat: "导出聊天",
      queue: "排队",
      queueMessage: "将消息排队",
      stop: "停止",
      stopGenerating: "停止生成",
      send: "发送",
      sendMessage: "发送消息",
    },
    queue: {
      retry: "重试",
      retrySend: "重试发送",
      retryQueuedMessage: "重试排队消息",
    },
    modelPicker: {
      discard: "放弃",
      faster: "更快",
      smarter: "更智能",
      useDefaultModel: "使用默认模型",
    },
    pairingQrExpired: {
      title: "配对二维码已过期",
      reason: "再次运行 /pair qr 以生成新的设置代码。",
      badge: "已过期",
    },
    composer: {
      placeholder: "给 {name} 发消息",
      placeholderWithAttachments: "添加消息或继续粘贴图片...",
      placeholderDisconnected: "连接到网关后开始聊天...",
      addAttachment: "添加附件",
      attachPhoto: "照片",
      attachFile: "附加文件",
      attachFileOption: "文件",
      contextUsage: {
        title: "上下文使用详情",
        open: "打开上下文使用详情",
        summary: "会话上下文使用情况：{used} / {limit}（{pct}%）",
        contextWindow: "上下文窗口",
        latestRunTokens: "最新运行令牌",
        estimatedCost: "预估成本",
      },
      takePhoto: "拍照",
      dismissVoiceInputError: "关闭语音输入错误",
      loadingMicrophones: "正在加载麦克风…",
      microphoneAccessFailed: "无法访问麦克风输入。",
      microphoneBusy: "麦克风输入正忙或浏览器无法使用。",
      microphoneFallback: "麦克风 {number}",
      microphoneInput: "麦克风输入",
      microphoneListUnsupported: "此浏览器无法列出麦克风输入。",
      noMicrophones: "未找到其他麦克风",
      microphoneNoneFound: "未找到麦克风输入。",
      microphonePageInactive: "此页面处于非活动状态时，麦克风输入不可用。",
      microphonePermissionBlocked: "麦克风访问被阻止。请在浏览器的网站设置中允许访问以列出输入。",
      realtimeTalkRequiresMicrophone: "实时语音输入需要浏览器麦克风访问权限。",
      selectedMicrophoneUnavailable: "所选麦克风不可用。请选择其他输入或系统默认。",
      startVoiceInput: "开始语音输入",
      stillListening: "仍在聆听",
      stopVoiceInput: "停止语音输入",
      systemDefaultMicrophone: "系统默认",
      talkAdvancedSettingsRequiresAdmin: "高级设置需要管理员权限",
      talkAdvancedSettingsRequiresAdminTitle: "高级 Talk 设置需要 operator.admin 权限。",
      talkDefault: "默认",
      talkModel: "模型",
      talkModelAuto: "自动",
      talkMoreInSettings: "设置中更多选项",
      talkSensitivity: "灵敏度",
      talkSensitivityHigh: "高",
      talkSensitivityLow: "低",
      talkSensitivityMedium: "中",
      talkVoice: "语音",
      voiceOptions: "语音选项",
      voiceTranscript: "语音转录",
    },
    selectors: {
      agentFilter: "按代理筛选会话",
      session: "聊天会话",
      sessionSearch: "搜索会话",
      clearSessionSearch: "清除会话搜索",
      loadMoreSessions: "加载更多会话",
      model: "聊天模型",
      thinkingLevel: "聊天思考级别",
    },
    toolCards: {
      toolError: "工具错误",
    },
    workspaceFiles: {
      label: "会话工作区",
      expand: "展开会话工作区",
      collapse: "收起会话工作区",
      workspace: "会话",
      files: "工作区",
      refresh: "刷新会话工作区",
      loading: "正在加载会话工作区……",
      empty: "此会话中尚未处理任何文件",
      changed: "已更改",
      read: "已读取",
      artifacts: "工件",
      browser: "项目文件",
      path: "工作区路径",
      root: "根目录",
      search: "搜索文件",
      searchResults: "搜索结果",
      parentFolder: "上级文件夹",
      noBrowserFiles: "此文件夹中没有文件。",
      noSearchResults: "没有匹配的文件。",
      truncated: "正在显示前几个匹配的文件。优化搜索以缩小结果范围。",
      session: "会话",
      missing: "缺失",
      summary: "会话工作区摘要",
      changedCount: "{count} 个已更改",
      readCount: "{count} 个已读取",
      artifactCount: "{count} 个工件",
      browserCount: "已显示 {count} 个",
      actions: "工作区文件操作",
      preview: "预览",
      copyPath: "复制路径",
    },
  },
  languages: {
    en: "英语",
    zhCN: "简体中文 (简体中文)",
    zhTW: "繁體中文 (繁体中文)",
    ptBR: "Português (巴西葡萄牙语)",
    de: "Deutsch (德语)",
    es: "Español (西班牙语)",
    jaJP: "日本語（Japanese）",
    ko: "한국어（Korean）",
    fr: "Français（French）",
    hi: "हिन्दी（印地语）",
    ar: "العربية（阿拉伯语）",
    it: "Italiano（意大利语）",
    tr: "Türkçe（Turkish）",
    uk: "乌克兰语（Ukrainian）",
    id: "Bahasa Indonesia（Indonesian）",
    pl: "Polski（Polish）",
    th: "ไทย (泰语)",
    vi: "Tiếng Việt（越南语）",
    nl: "Nederlands（荷兰语）",
    fa: "فارسی（波斯语）",
    ru: "Русский（俄语）",
  },
  cron: {
    quickCreate: {
      schedules: {
        everyMorning: {
          label: "每天早上",
          description: "每天上午 8:00",
        },
        everyEvening: {
          label: "每天晚上",
          description: "每天晚上 6:00",
        },
        hourly: {
          label: "每小时",
          description: "每小时",
        },
        weekdays: {
          label: "工作日",
          description: "周一至周五上午 9:00",
        },
        weekly: {
          label: "每周",
          description: "每周一上午 9:00",
        },
        once: {
          label: "运行一次",
          description: "一次性，运行后删除",
        },
      },
      delivery: {
        notify: {
          label: "通知我",
          description: "将结果发送到聊天",
        },
        silent: {
          label: "静默",
          description: "运行时不通知",
        },
        isolated: {
          label: "独立会话",
          description: "在自己的会话中运行",
        },
      },
      steps: {
        what: "内容",
        when: "时间",
        how: "方式",
      },
      defaultName: "自动化",
      whatHeading: "它应该做什么？",
      whatHint: "用自然语言描述任务。代理每次都会运行此提示。",
      promptPlaceholder: "例如，检查我的收件箱中是否有紧急邮件并进行总结...",
      nameOptional: "名称（可选）",
      namePlaceholder: "例如，早间收件箱检查",
      whenHeading: "它应该什么时候运行？",
      whenHint: "选择一个时间表。稍后可以微调。",
      howHeading: "它应该如何工作？",
      howHint: "选择结果的发送方式。",
      title: "新建自动化",
    },
    summary: {
      enabled: "已启用",
      yes: "是",
      no: "否",
      jobs: "任务数",
      nextWake: "下次唤醒",
      refreshing: "刷新中...",
      refresh: "刷新",
    },
    jobs: {
      title: "任务列表",
      subtitle: "网关中存储的所有定时任务。",
      shownOf: "显示 {shown} / 共 {total}",
      searchJobs: "搜索任务",
      searchPlaceholder: "名称、描述或代理",
      enabled: "启用状态",
      schedule: "计划",
      lastRun: "上次运行",
      all: "全部",
      sort: "排序",
      nextRun: "下次运行",
      recentlyUpdated: "最近更新",
      name: "姓名",
      direction: "方向",
      ascending: "升序",
      descending: "降序",
      reset: "重置",
      emptyTitle: "No scheduled jobs yet.",
      emptyHint: "Create one from a plain-language prompt; advanced fields can wait.",
      emptyFilteredHint: "Clear or change filters to see scheduled jobs.",
      noMatching: "没有匹配的任务。",
      loading: "加载中...",
      loadMore: "加载更多任务",
    },
    runs: {
      title: "运行历史",
      subtitleAll: "所有任务的最新运行记录。",
      subtitleJob: "{title} 的最新运行记录。",
      scope: "范围",
      allJobs: "所有任务",
      selectedJob: "已选任务",
      searchRuns: "搜索运行",
      searchPlaceholder: "摘要、错误或任务",
      newestFirst: "最新优先",
      oldestFirst: "最早优先",
      status: "状态",
      delivery: "投递",
      clear: "清除",
      allStatuses: "全部状态",
      allDelivery: "全部投递",
      selectJobHint: "请选择一个任务以查看运行历史。",
      noMatching: "没有匹配的运行记录。",
      loadMore: "加载更多运行",
      runStatusOk: "成功",
      runStatusError: "错误",
      runStatusSkipped: "已跳过",
      runStatusUnknown: "未知",
      deliveryDelivered: "已投递",
      deliveryNotDelivered: "未投递",
      deliveryUnknown: "未知",
      deliveryNotRequested: "未请求",
    },
    form: {
      editJob: "编辑任务",
      newJob: "新建任务",
      advancedJob: "Advanced job",
      updateSubtitle: "更新所选定时任务。",
      createSubtitle: "创建定时唤醒或代理运行。",
      required: "必填",
      requiredSr: "必填",
      basics: "基本信息",
      basicsSub: "命名、选择助手并设置启用状态。",
      fieldName: "姓名",
      description: "描述",
      agentId: "代理 ID",
      namePlaceholder: "晨间简报",
      descriptionPlaceholder: "此任务的可选说明",
      agentPlaceholder: "main 或 ops",
      agentHelp: "输入以选择已知代理，或输入自定义 ID。",
      schedule: "计划",
      scheduleSub: "控制任务运行时间。",
      every: "每隔",
      at: "指定时间",
      cronOption: "Cron",
      runAt: "运行时间",
      unit: "单位",
      minutes: "分钟",
      hours: "小时",
      days: "天",
      expression: "表达式",
      expressionPlaceholder: "0 7 * * *",
      everyAmountPlaceholder: "30",
      timezoneOptional: "时区（可选）",
      timezonePlaceholder: "America/Los_Angeles",
      timezoneHelp: "选择常用时区或输入有效的 IANA 时区。",
      jitterHelp: "需要抖动？使用高级 → 抖动窗口 / 抖动单位。",
      execution: "执行",
      executionSub: "选择唤醒时机和任务执行内容。",
      session: "会话",
      main: "主会话",
      isolated: "隔离会话",
      sessionHelp: "主会话发布系统事件。隔离会话运行独立的代理轮次。",
      wakeMode: "唤醒模式",
      now: "立即",
      nextHeartbeat: "下次心跳",
      wakeModeHelp: "立即模式立即触发。下次心跳等待下一个周期。",
      payloadKind: "执行内容",
      command: "Command",
      systemEvent: "发布消息到主时间线",
      agentTurn: "运行助手任务（隔离）",
      systemEventHelp: "将文本发送到网关主时间线（适用于提醒/触发）。",
      agentTurnHelp: "使用您的提示在独立会话中启动助手运行。",
      timeoutSeconds: "超时（秒）",
      timeoutPlaceholder: "可选，如 90",
      timeoutHelp: "可选。留空以使用网关默认超时行为。",
      mainTimelineMessage: "主时间线消息",
      assistantTaskPrompt: "助手任务提示",
      deliverySection: "投递",
      deliverySub: "选择运行摘要的发送位置。",
      resultDelivery: "结果投递",
      announceDefault: "发布摘要（默认）",
      webhookPost: "Webhook POST",
      noneInternal: "无（仅内部）",
      deliveryHelp: "发布将摘要发送到聊天。无保持执行仅内部。",
      webhookUrl: "Webhook URL",
      channel: "渠道",
      webhookPlaceholder: "https://example.com/cron",
      channelHelp: "选择接收摘要的已连接频道。",
      webhookHelp: "将运行摘要发送到 Webhook 端点。",
      to: "收件人",
      toPlaceholder: "+1555... 或聊天 ID",
      toHelp: "可选收件人覆盖（聊天 ID、电话或用户 ID）。",
      advanced: "高级",
      advancedHelp: "投递保证、调度抖动和模型控制的可选覆盖。",
      deleteAfterRun: "运行后删除",
      deleteAfterRunHelp: "适用于应自动清理的一次性提醒。",
      clearAgentOverride: "清除代理覆盖",
      clearAgentHelp: "强制此任务使用网关默认助手。",
      exactTiming: "精确时间（无抖动）",
      exactTimingHelp: "在精确的 cron 边界运行，无分散。",
      staggerWindow: "抖动窗口",
      staggerUnit: "抖动单位",
      staggerPlaceholder: "30",
      seconds: "秒",
      model: "模型",
      modelPlaceholder: "openai/gpt-5.2",
      modelHelp: "输入以选择已知模型，或输入自定义模型。",
      thinking: "思考",
      thinkingPlaceholder: "low",
      thinkingHelp: "使用建议级别或输入提供商特定值。",
      bestEffortDelivery: "尽力投递",
      bestEffortHelp: "投递失败时不使任务失败。",
      cantAddYet: "暂无法添加任务",
      fillRequired: "填写下方必填项以启用提交。",
      fixFields: "修复 {count} 个字段以继续。",
      fixFieldsPlural: "修复 {count} 个字段以继续。",
      saving: "保存中...",
      saveChanges: "保存更改",
      addJob: "添加任务",
      cancel: "取消",
    },
    jobList: {
      allJobs: "所有任务",
      selectJob: "（选择任务）",
      enabled: "已启用",
      disabled: "已禁用",
      edit: "编辑",
      clone: "克隆",
      disable: "禁用",
      enable: "启用",
      run: "运行",
      runIfDue: "到期时运行",
      moreActions: "更多操作",
      history: "历史",
      remove: "删除",
    },
    jobDetail: {
      system: "系统",
      command: "命令",
      cwd: "CWD",
      prompt: "提示",
      delivery: "投递",
      agent: "代理",
    },
    jobState: {
      status: "状态",
      next: "下次",
      last: "上次",
    },
    runEntry: {
      noSummary: "无摘要。",
      runAt: "运行于",
      openRunChat: "打开运行聊天",
      next: "下次 {rel}",
      due: "到期 {rel}",
    },
    errors: {
      nameRequired: "名称为必填项。",
      scheduleAtInvalid: "请输入有效的日期/时间。",
      everyAmountInvalid: "间隔必须大于 0。",
      cronExprRequired: "Cron 表达式为必填项。",
      staggerAmountInvalid: "抖动值必须大于 0。",
      systemTextRequired: "系统文本为必填项。",
      agentMessageRequired: "代理消息为必填项。",
      timeoutInvalid: "若设置超时，必须大于 0 秒。",
      webhookUrlRequired: "Webhook URL 为必填项。",
      webhookUrlInvalid: "Webhook URL 必须以 http:// 或 https:// 开头。",
      invalidRunTime: "无效的运行时间。",
      invalidIntervalAmount: "无效的间隔值。",
      cronExprRequiredShort: "Cron 表达式为必填。",
      invalidStaggerAmount: "无效的抖动值。",
      systemEventTextRequired: "系统事件文本为必填。",
      agentMessageRequiredShort: "代理消息为必填。",
      nameRequiredShort: "名称为必填。",
    },
  },
};
